import React from 'react';
import './LookingForward.css';
import worldMapBg from '../../Assets/map.png'; // Use your dark map background image
import avatarImg from '../../Assets/avatar-icon.png'; // Replace with actual avatar
import VCNRMapEmbed from '../Contact/VCNRLocationMap';

const cards = [
  { city: "New York", items: 33, eth: "4.83 ETH", top: "22%", left: "17%" },
  { city: "Cape Town", items: 33, eth: "4.01 ETH", top: "57%", left: "22%" },
  { city: "Mumbai", items: 33, eth: "4.87 ETH", top: "29%", left: "60%" },
  { city: "Sydney", items: 33, eth: "4.05 ETH", top: "62%", left: "79%" },
  { city: "London", items: 33, eth: "4.15 ETH", top: "19%", left: "37%" }
];

const LookingForwardMap = () => {
  return (
    <section className="lf-section">
      <div className="lf-header">
        <h2 className="lf-title">Looking Forward</h2>
        <p className="lf-subtitle">Expanding Our Impact</p>
        <p className="lf-desc">
With a growing footprint across multiple states and a rising international presence, VCNR is poised for its next chapter, global impact. Our upcoming ventures in aerospace, mall infrastructure, and advanced R&D labs reflect our commitment to building for the future, not just in scale, but in relevance and responsibility. We believe the best ideas emerge when there’s a clear purpose behind them. As we move ahead, we invite start-ups, investors, policymakers, and grassroots changemakers to join us in shaping a better tomorrow. Let’s build what matters. Together.
</p></div>

<VCNRMapEmbed />

     {/* <div className="map-graphic">
  <img src={worldMapBg} alt="Global Network" className="map-bg" />
  {cards.map((card, idx) => (
    <div
      key={idx}
      className="location-card"
      style={{ top: card.top, left: card.left }}
    >
      <div className="card-box">
        <div className="avatar-box">
          <img src={avatarImg} alt="avatar" className="avatar-img" />
        </div>
        <div className="info-box">
          <p className="city-name">{card.city}</p>
          <p className="eth-text">{card.eth}</p>
        </div>
        <div className="divider" />
        <div className="item-box">
          <p className="item-count">{card.items}</p>
          <p className="item-label">Items</p>
        </div>
      </div>
      <div className="card-pointer-notch"></div>
    </div>
  ))}
</div> */}

{/* Table View (shown only on mobile/tablet) */}
{/* <table className="location-table">
  <thead>
    <tr>
      <th>City</th>
      <th>ETH</th>
      <th>Items</th>
    </tr>
  </thead>
  <tbody>
    {cards.map((card, index) => (
      <tr key={index}>
        <td>{card.city}</td>
        <td>{card.eth}</td>
        <td>{card.items}</td>
      </tr>
    ))}
  </tbody>
</table> */}


      {/* <div className="lf-btn-wrapper">
        <button className="lf-btn">View Our Global Presence</button>
      </div> */}
    </section>
  );
};

export default LookingForwardMap;
